import { create } from "zustand";
import type { ParentRole } from "@starquest/core";

function normalizeRole(r: string | null): ParentRole | null {
  if (r === "super_master") return "admin";
  if (r === "quest_master") return "manager";
  return r as ParentRole | null;
}

function deriveFlags(role: ParentRole | null) {
  const isAdmin   = role === "admin";
  const isManager = role === "manager";
  const isViewer  = role === "viewer";
  return {
    isAdmin, isManager, isViewer,
    isSuper: isAdmin,           // backward compat alias
    canApprove: isAdmin || isManager,
    canManageKids: isAdmin || isManager,
  };
}

interface AuthState {
  token: string | null;
  familyId: string | null;
  email: string | null;
  parentRole: ParentRole | null;
  isSuper: boolean;
  isAdmin: boolean;
  isManager: boolean;
  isViewer: boolean;
  canApprove: boolean;
  canManageKids: boolean;
  setAuth: (token: string, familyId: string, email: string, parentRole: ParentRole) => void;
  clearAuth: () => void;
}

const storedRole   = normalizeRole(localStorage.getItem("sq_parent_role"));
const stored       = localStorage.getItem("sq_token");
const storedFamily = localStorage.getItem("sq_family");
const storedEmail  = localStorage.getItem("sq_email");

export const useAuthStore = create<AuthState>((set) => ({
  token:      stored       ?? null,
  familyId:   storedFamily ?? null,
  email:      storedEmail  ?? null,
  parentRole: storedRole   ?? null,
  ...deriveFlags(storedRole),

  setAuth: (token, familyId, email, parentRole) => {
    const normalized = normalizeRole(parentRole as string) ?? "viewer";
    localStorage.setItem("sq_token",       token);
    localStorage.setItem("sq_family",      familyId);
    localStorage.setItem("sq_email",       email);
    localStorage.setItem("sq_parent_role", normalized);
    set({ token, familyId, email, parentRole: normalized, ...deriveFlags(normalized) });
  },

  clearAuth: () => {
    localStorage.removeItem("sq_token");
    localStorage.removeItem("sq_family");
    localStorage.removeItem("sq_email");
    localStorage.removeItem("sq_parent_role");
    localStorage.removeItem("sq_kid_id");
    set({ token: null, familyId: null, email: null, parentRole: null, ...deriveFlags(null) });
  },
}));
